import { render } from "./pageTrainCourse.vue?vue&type=template&id=1cc63cac&scoped=true"
import script from "./pageTrainCourse.vue?vue&type=script&lang=js"
export * from "./pageTrainCourse.vue?vue&type=script&lang=js"

import "./pageTrainCourse.vue?vue&type=style&index=0&id=1cc63cac&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc63cac"]])

export default __exports__